import {
  GetMarketForm,
  GetMarketListImportantWithGOLD,
  GetMarketLoggedInForm,
  GetMarketLoggedInList,
  GetSingleMarketLoggedInList,
  MarketFavorite,
} from "./api";

import http from "config/http";

const marketApi = {
  getMarketForm: async () => await http.get(GetMarketForm),

  getMarketLoggedInForm: async () => await http.get(GetMarketLoggedInForm),

  getMarketLoggedInList: async ({ coinDestinationId }) =>
    await http.get(GetMarketLoggedInList({ coinDestinationId })),

  getSingleMarketLoggedInList: async ({ coinDestinationId, coinSourceId }) =>
    await http.get(
      GetSingleMarketLoggedInList({
        coinSourceId,
        coinDestinationId,
      })
    ),

  getMarketListImportantWithGOLD: async () =>
    await http.get(GetMarketListImportantWithGOLD),

  markFavorite: async ({ coinSourceId, coinDestinationId, isRemove }) =>
    await http.post(MarketFavorite, {
      coinSourceId,
      coinDestinationId,
      isRemove,
    }),
};

export default marketApi;
